/* AUD reference pricing for visitors in Australia (RWC 2027 pages only).
   The store charges in USD (no Shopify Payments, so no true multi-currency).
   This shows an approximate AUD figure next to USD prices, clearly labeled.
   Detection: browser timezone Australia/*, so only actual AU visitors see it
   and cached pages stay identical for everyone else. */
(function () {
  'use strict';
  var tz = '';
  try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { return; }
  if (tz.indexOf('Australia/') !== 0) return;

  var FALLBACK_RATE = 1.55;
  var LS_KEY = 'gt_usd_aud_rate';

  function getRate(cb) {
    try {
      var cached = JSON.parse(localStorage.getItem(LS_KEY) || 'null');
      if (cached && cached.t && Date.now() - cached.t < 86400000 && cached.r > 1 && cached.r < 3) {
        return cb(cached.r);
      }
    } catch (e) {}
    fetch('https://open.er-api.com/v6/latest/USD')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var r = d && d.rates && d.rates.AUD;
        if (r && r > 1 && r < 3) {
          try { localStorage.setItem(LS_KEY, JSON.stringify({ r: r, t: Date.now() })); } catch (e) {}
          cb(r);
        } else cb(FALLBACK_RATE);
      })
      .catch(function () { cb(FALLBACK_RATE); });
  }

  function fmtAud(usd, rate) {
    var aud = Math.round(usd * rate);
    return 'A$' + aud.toLocaleString('en-AU');
  }

  function annotate(rate) {
    // Elements with exact cents
    var els = document.querySelectorAll('.price-value[data-usd-cents]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.querySelector('.aud-hint') || (el.nextElementSibling && el.nextElementSibling.classList && el.nextElementSibling.classList.contains('aud-hint'))) continue;
      var cents = parseInt(el.getAttribute('data-usd-cents'), 10);
      if (!cents) continue;
      var s = document.createElement('span');
      s.className = 'aud-hint';
      s.textContent = ' ≈ ' + fmtAud(cents / 100, rate);
      el.insertAdjacentElement('afterend', s);
    }
    // Sticky CTA price (text like "$375")
    var sticky = document.querySelectorAll('.sticky-cta__price, .sticky-cta-price');
    for (var j = 0; j < sticky.length; j++) {
      var st = sticky[j];
      if (st.querySelector('.aud-hint')) continue;
      var m = (st.textContent || '').match(/\$\s?([\d,]+)/);
      if (!m) continue;
      var usd = parseInt(m[1].replace(/,/g, ''), 10);
      if (!usd) continue;
      var s2 = document.createElement('span');
      s2.className = 'aud-hint';
      s2.textContent = ' ≈ ' + fmtAud(usd, rate);
      st.appendChild(s2);
    }
  }

  function banner() {
    if (document.getElementById('aud-notice')) return;
    var b = document.createElement('div');
    b.id = 'aud-notice';
    b.setAttribute('role', 'note');
    b.innerHTML = 'Prices are in <strong>USD</strong>. Approximate AUD amounts are shown for reference; your card is charged in USD and converted by your bank.';
    var main = document.querySelector('main') || document.body;
    main.insertBefore(b, main.firstChild);
  }

  function css() {
    var st = document.createElement('style');
    st.textContent =
      '#aud-notice{background:#f0f4fa;color:#25384d;border-bottom:1px solid #d7e0ec;padding:9px 16px;font-size:13.5px;text-align:center;line-height:1.4}' +
      '.aud-hint{font-size:.8em;color:#6b7788;font-weight:500;white-space:nowrap}';
    document.head.appendChild(st);
  }

  getRate(function (rate) {
    css();
    banner();
    annotate(rate);
    // Prices can re-render on variant selection; re-annotate on DOM changes (debounced)
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { annotate(rate); }, 250);
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
